// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"192":"31d0f115","253":"ae177835","453":"3c771bea","530":"6676c09f"}[chunkId] + ".chunk.js";
};